/** If we have bounds, return total hits, otherwise return batchsize */
export function getTakeParam(SearchResult) {
  const { TotalHits, BatchSize, Bounds } = SearchResult;
  return Bounds ? Number(TotalHits) : Number(BatchSize);
}

export function setMaxZoom(map) {
  if (map.getZoom() >= 22) {
    map.setZoom(18);
  }
}

export function isEqPositionTo(compare) {
  return function(compareWith) {
    return Boolean(
      compareWith.data.Latitude === compare.data.Latitude &&
        compareWith.data.Longitude === compare.data.Longitude
    );
  };
}

export function onlyHitsOutsideBounds(qs, bounds) {
  if (!bounds && qs.location) {
    return true;
  }
  return false;
}

/** Return { ne, sw } from SearchResult if available */
export function getInitialBounds(SearchResult) {
  if (!SearchResult.Bounds) {
    return null;
  }
  const { topLeft, bottomRight } = SearchResult.Bounds;
  return {
    ne: { latitude: topLeft.latitude, longitude: bottomRight.longitude },
    sw: { latitude: bottomRight.latitude, longitude: topLeft.longitude },
  };
}

export function getDefaultCenter(SearchResult) {
  return {
    lat: SearchResult.Latitude || 61.2291259,
    lng: SearchResult.Longitude || 16.0703703,
  };
}

export function getHsaIdsPiped(SearchResult) {
  let hsaIds = '';
  SearchResult &&
    SearchResult.SearchHits.forEach((item) => {
      hsaIds = hsaIds + `${item.HsaId}|`;
    });
  return hsaIds;
}

export function getZoomLevel(qs) {
  return !isNaN(parseInt(qs.z, 10)) ? parseInt(qs.z, 10) : 16;
}

/** Extract location data and HsaId from an object. */
export function getLocationData({ HsaId, Latitude, Longitude }) {
  return {
    HsaId,
    Latitude,
    Longitude,
  };
}

export function getCoordsFromBoundaryQuery(boundaryQuery) {
  let coords = boundaryQuery.split('|');
  const sw = { lat: parseFloat(coords[3]), lng: parseFloat(coords[0]) };
  const ne = { lat: parseFloat(coords[1]), lng: parseFloat(coords[2]) };
  return [sw, ne];
}

export function shouldDoInitialBoundaryQuery(qs, SearchResult) {
  return (qs.location || qs.nearby === 'true') && !SearchResult.Bounds;
}

export function shouldRedirectToLatLng(qs) {
  return !('lat' in qs) && !('lng' in qs) && qs.nearby === 'true';
}

export function sanitizeHeading(heading) {
  if (!heading) return;
  return heading.replace(/<\/strong>/g, '|||').replace(/<strong>/g, '||');
}

export function parseSanitizedHeading(heading) {
  if (!heading) return;
  return heading.replace(/\|\|\|/g, '</strong>').replace(/\|\|/g, '<strong>');
}

export function noSearchHits(SearchResult) {
  return (
    !SearchResult ||
    !SearchResult.SearchHits ||
    SearchResult.SearchHits.length === 0
  );
}

export function shouldDisplayMap(qs, SearchResult) {
  return !(!qs.b && noSearchHits(SearchResult));
}

export function shouldDisplaySort({ SearchResult, IsPost }) {
  if (IsPost) {
    return false;
  }
  if (noSearchHits(SearchResult)) {
    return false;
  }
  if (!SearchResult.Bounds) {
    return false;
  }
  return true;
}
